export function addCallRail() {
  if (document.getElementById("callrail-script")) {
    return;
  }
  const script = document.createElement("script");
  script.id = "callrail-script";
  script.type = "text/javascript";
  script.src =
    "//cdn.calltrk.com/companies/234147993/5551ec6710b5179ad395/12/swap.js";
  document.head.appendChild(script);
}
